import { useCallback } from 'react';

import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { CreateResponsiveStyle, DEVICE_SIZES, minSize } from 'rn-responsive-styles';

import { Button, Text, spacing } from '@pletly/ui';
import { EmptyConnections } from '%components/EmptyConnections';
import { useCreateAccount } from '%services/payment/useCreateAccount';
import { CONNECTIONS_MANAGE_ENABLED } from '%constants/connections';

export const EmptyList = () => {
	const { t } = useTranslation();
	const { navigate } = useNavigation();
	const { goToCreateAccount } = useCreateAccount();
	const styles = useStyles();

	const goToConnect = useCallback(() => navigate('ConnectUser'), [navigate]);

	return (
		<EmptyConnections titleCategory="h4">
			{CONNECTIONS_MANAGE_ENABLED && (
				<>
					<Text category="p1" style={styles.description} align="center">
						{t('connections.choose-how-you-want-to-connect-care-receiver')}
					</Text>
					<View style={styles.actions}>
						<Button size="medium" variant="filled" color="primary" onPress={goToCreateAccount}>
							{t('connections.create-care-receiver')}
						</Button>
						<Button size="medium" variant="outline" color="primary" onPress={goToConnect}>
							{t('connections.connect-to-care-receiver')}
						</Button>
					</View>
				</>
			)}
		</EmptyConnections>
	);
};

const useStyles = CreateResponsiveStyle(
	{
		description: {
			maxWidth: 425,
		},
		actions: {
			flexDirection: 'column',
			gap: spacing(2),
			marginTop: spacing(4),
		},
	},
	{
		[minSize(DEVICE_SIZES.LG)]: {
			actions: {
				flexDirection: 'row',
			},
		},
	},
);
